import React from "react";
import Navbar from "./components/Navbar";
import GydeHero from "./components/GydeHero";
import HowItWorks from "./components/HowItWorks";
import GydeHealthSection from "./components/GydeHealthSection";
import WhyGyde from "./components/WhyGyde";
import TeamSection from "./components/TeamSection";

function App() {
  return (
    <div>
      <Navbar />

      <GydeHero />

      <div id="technology">
        <HowItWorks />
      </div>

      <div id="health">
        <GydeHealthSection />
      </div>

      <div id="about">
        <WhyGyde />
      </div>

      <div id="team">
        <TeamSection />
      </div>
    </div>
  );
}

export default App;